module.exports = __webpack_public_path__ + "img/como_lo_hacemos.48b719f9.jpg";